import React from "react";
import {push} from "connected-react-router";
import {changeRedirectState} from "../../redux/global/redirect/actions";
import PropTypes from "prop-types";
import {createStructuredSelector} from "reselect";
import {makeRedirectUrl} from "../../redux/global/redirect/selector";
import connect from "react-redux/es/connect/connect";
import {compose} from "redux";
import {Grid, GridColumn, GridRow, Container, Image} from "semantic-ui-react";
import styled from 'styled-components';


export class SocialMediaContact extends React.PureComponent {

    constructor(props, context) {
        super(props, context);
    }

    render() {
        const SocialMediaWrapper = styled(Grid)`
        `;

        const socialMedia = this.props.socialMediaList.map(data => {
            return <GridColumn key={data.key}>
                    <Container style={{marginTop:'20px'}}>
                        <a onClick={() => this.props.handleRedirect(data.url)}>
                            <Image src={ data.media } style={{width:'50px',height:'100%'}}/>
                        </a>
                    </Container>
                </GridColumn>
        });


        return (
            <SocialMediaWrapper columns={this.props.socialMediaList.length}>
                <GridRow>
                    {socialMedia}
                </GridRow>
            </SocialMediaWrapper>
        );
    }
}

export function mapDispatchToProps(dispatch) {
    return {
        handleRedirect: (url) => {
            if (url) {
                dispatch(push('/redirect'));
                dispatch(changeRedirectState(url));
                window.scrollTo(0, 0);
            }
        }
    };
}

SocialMediaContact.propTypes = {
    handleRedirect: PropTypes.func,
    socialMediaList: PropTypes.array.isRequired
};

const mapStateToProps = createStructuredSelector({
    redirectState: makeRedirectUrl()
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(SocialMediaContact);


// WEBPACK FOOTER //
// ./src/components/Footer/SocialMediaContact.js